import { motion } from "framer-motion";
import { IMAGES } from "../../lib/constants";

const phrases = [
    "NO VENDEMOS EXCUSAS",
    "VENDEMOS RESULTADOS",
    "DISCIPLINA",
    "CONSTANCIA",
    "FUERZA",
    "MENTALIDAD GANADORA",
];

export default function NoExcusas() {
    return (
        <section
            data-testid="no-excusas-section"
            className="relative bg-[#050505] py-24 md:py-32 overflow-hidden"
        >
            {/* Marquee top */}
            <div className="border-y border-white/10 py-6 overflow-hidden">
                <div className="flex marquee-track whitespace-nowrap">
                    {[...phrases, ...phrases, ...phrases].map((p, i) => (
                        <span
                            key={i}
                            className="font-display text-5xl md:text-7xl tracking-tight text-brand-text mx-8 flex items-center gap-8"
                        >
                            {p}
                            <span className="w-3 h-3 bg-brand-orange" />
                        </span>
                    ))}
                </div>
            </div>

            <div className="max-w-7xl mx-auto px-5 md:px-10 mt-20 grid lg:grid-cols-12 gap-10 items-center">
                <motion.div
                    initial={{ opacity: 0, x: -40 }}
                    whileInView={{ opacity: 1, x: 0 }}
                    viewport={{ once: true, amount: 0.3 }}
                    transition={{ duration: 0.8 }}
                    className="lg:col-span-7"
                >
                    <span className="font-display tracking-[0.4em] text-xs text-brand-orange">
                        // MENTALIDAD F YOU
                    </span>
                    <h2 className="font-display text-5xl md:text-7xl lg:text-8xl mt-5 leading-[0.9] text-brand-text">
                        TU CUERPO CAMBIA
                        <br />
                        CUANDO TU MENTE
                        <br />
                        <span className="orange-text">DEJA DE RENDIRSE.</span>
                    </h2>
                    <p className="mt-8 text-lg text-brand-muted max-w-xl leading-relaxed">
                        No necesitas más motivación. Necesitas{" "}
                        <span className="text-brand-text">empezar</span> y
                        confiar el proceso a profesionales que te exigirán cada
                        sesión, te corregirán cada repetición y te llevarán
                        donde tú solo nunca llegarías.
                    </p>

                    <div className="mt-12 grid grid-cols-3 gap-4 max-w-xl">
                        {[
                            { n: "100%", l: "PERSONALIZADO" },
                            { n: "7+", l: "AÑOS EXIGIENDO" },
                            { n: "0", l: "EXCUSAS ACEPTADAS" },
                        ].map((s) => (
                            <div
                                key={s.l}
                                className="border-l-2 border-brand-orange pl-4"
                            >
                                <div className="font-display text-3xl md:text-4xl text-brand-text">
                                    {s.n}
                                </div>
                                <div className="font-display text-[10px] tracking-[0.25em] text-brand-muted mt-1">
                                    {s.l}
                                </div>
                            </div>
                        ))}
                    </div>
                </motion.div>

                <motion.div
                    initial={{ opacity: 0, scale: 0.95 }}
                    whileInView={{ opacity: 1, scale: 1 }}
                    viewport={{ once: true, amount: 0.3 }}
                    transition={{ duration: 0.9 }}
                    className="lg:col-span-5 relative h-[480px] md:h-[600px] overflow-hidden"
                >
                    <img
                        src={IMAGES.sweat}
                        alt="Esfuerzo y sudor"
                        className="w-full h-full object-cover grayscale contrast-125"
                    />
                    <div className="absolute inset-0 bg-gradient-to-t from-[#050505] via-transparent to-transparent" />
                    <div className="absolute bottom-6 left-6 right-6">
                        <p className="font-display text-2xl md:text-3xl leading-tight text-brand-text">
                            "Resultados reales para personas{" "}
                            <span className="text-brand-orange">
                                comprometidas
                            </span>
                            ."
                        </p>
                    </div>
                    <div className="absolute top-4 right-4 border border-brand-gold px-3 py-1 font-display tracking-[0.3em] text-[10px] text-brand-gold">
                        ZERO EXCUSAS
                    </div>
                </motion.div>
            </div>
        </section>
    );
}
